module.exports = __webpack_public_path__ + "img/oliver-borner8.b00cac62.jpg";